import React, { Fragment, useState, useRef } from "react";
import { InputBase } from "@material-ui/core";
import { BiSearch } from "react-icons/bi";
import Select from "react-select";
import { MdDateRange } from "react-icons/md";
import { DateRangePicker } from "react-date-range";
import { addDays } from "date-fns";
import { format } from "date-fns";
import { set_orders } from "../../../redux/actions/OrdersAction";
import { connect } from "react-redux";

import { useOutsideAlerter } from "../../../utils/CustomHooks";
import "../../../../node_modules/react-date-range/dist/styles.css";
import "../../../../node_modules/react-date-range/dist/theme/default.css";
import "./header.scss";

const filters = [
  { value: 1, label: "Status: All" },
  { value: 2, label: "Status: Pending" },
  { value: 3, label: "Status: Shiped" },
  { value: 4, label: "Status: Delivered" },
];

const Header = (props) => {
  const wrapperRef = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [filter, setfilter] = useState(filters[0]);
  const [show, setshow] = useState(false);
  useOutsideAlerter(wrapperRef, setshow);
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ]);

  const filterChange = (filter) => {
    setfilter(filter);
  };

  const onSeacrhChange = (e) => {
    setSearchText(e.target.value);
    props.handleSearch(e.target.value);
  };

  const styles =
    props.filters && !props.filters.date_filter
      ? { marginRight: "0px" }
      : { marginRight: "30px" };
  return (
    <Fragment>
      <div className="vendor-pages-header-desktop">
        <div className="row mx-auto w-100 header-row justify-content-between align-items-center">
          <div className="heading-col d-flex align-items-center">
            <div className="heading">{props.heading}</div>
            {props.search && (
              <Fragment>
                <div className="line"></div>
                <div className="search">
                  <div className="search-container">
                    <InputBase
                      placeholder="Search…"
                      onChange={onSeacrhChange}
                      value={searchText}
                      classes={{
                        root: "input-root",
                        input: "input-input",
                      }}
                      inputProps={{ "aria-label": "search" }}
                    />
                    <div className="search-icon d-flex justify-content-center align-items-center">
                      <BiSearch />
                    </div>
                  </div>
                </div>
              </Fragment>
            )}
          </div>
          {props.filters && (
            <div className="filter-col d-flex align-items-center">
              {props.filters && props.filters.status && (
                <div className="select" style={styles}>
                  <Select
                    value={filter}
                    onChange={filterChange}
                    options={filters}
                    className="filter"
                    classNamePrefix="control"
                    isSearchable={false}
                  />
                </div>
              )}
              {props.filters && props.filters.date_filter && (
                <div
                  className="date-rangepicker d-flex align-items-center"
                  ref={wrapperRef}
                  onClick={() => setshow(true)}
                >
                  <div className="start-date">
                    {format(state[0].startDate, "MMM dd")}
                  </div>
                  <div className="date-seperator">-</div>
                  <div className="end-date">
                    {format(state[0].endDate, "MMM dd")}
                  </div>
                  <div className="date-icon">
                    <MdDateRange />
                  </div>
                  {show && (
                    <DateRangePicker
                      onChange={(item) => setState([item.selection])}
                      showSelectionPreview={true}
                      moveRangeOnFirstSelection={false}
                      months={1}
                      ranges={state}
                      direction="horizontal"
                      className="date-picker"
                    />
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

const mapDispatchTopProps = {
  set_orders,
};

export default connect(null, mapDispatchTopProps)(Header);
